'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var buttonSizes = {
  SMALL: 'small',
  LARGE: 'large',
  DYNAMIC: 'dynamic'
};
var ALL_FOCUSABLE_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
var DEFAULT_CURRENCY_FORMAT = {
  CURRENCY: 'USD',
  DECIMALS: 0,
  DISPLAY_SYMBOL: 'narrowSymbol'
};

exports.ALL_FOCUSABLE_SELECTOR = ALL_FOCUSABLE_SELECTOR;
exports.DEFAULT_CURRENCY_FORMAT = DEFAULT_CURRENCY_FORMAT;
exports.buttonSizes = buttonSizes;
//# sourceMappingURL=constants.js.map
